import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { AdobeExperiencePlatformLinkedService } from 'app/model/linkedservice/adobe-experience-platform.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AdobeExperiencePlatformLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                apiKey: '*',
                accountId: '*',
                orgId: '*',
                clientSecret: 'secret',
                privateKeyContent: 'secret',
                encryptedCredential: '*'
            }
        }
    }
})
export class AdobeExperiencePlatformLinkedServiceAdapter extends LinkedServiceAdapter<AdobeExperiencePlatformLinkedService> {
    protected modelConstructor(): new () => AdobeExperiencePlatformLinkedService {
        return AdobeExperiencePlatformLinkedService;
    }

    protected model(): IModel {
        return AdobeExperiencePlatformLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AdobeExperiencePlatformLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AdobeExperiencePlatformLinkedService;
        properties.type = Metamodel.modelFor(AdobeExperiencePlatformLinkedService).name;

        properties.typeProperties = {
            apiKey: linkedService.apiKey,
            accountId: linkedService.accountId,
            orgId: linkedService.orgId,
            clientSecret: passwordOrAKVtoSecretBase(linkedService.clientSecret, this.context),
            privateKeyContent: passwordOrAKVtoSecretBase(linkedService.privateKeyContent, this.context)
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AdobeExperiencePlatformLinkedService): Promise<AdobeExperiencePlatformLinkedService> {
        const properties = linkedServiceResource.properties as Model.AdobeExperiencePlatformLinkedService;
        const typeProperties: Model.AdobeExperiencePlatformLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.apiKey = typeProperties.apiKey;
        linkedService.accountId = typeProperties.accountId;
        linkedService.orgId = typeProperties.orgId;
        linkedService.clientSecret = secretBaseToPasswordOrAKV(typeProperties.clientSecret, true, this.context);
        linkedService.privateKeyContent = secretBaseToPasswordOrAKV(typeProperties.privateKeyContent, true, this.context);

        return linkedService;
    }
}
